var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadCsvTemplate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13154_200137)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9549 7.293C11.9153 7.20555 11.8513 7.13139 11.7706 7.07942C11.6899 7.02745 11.5959 6.99987 11.4999 7H9.49994V0.5C9.49994 0.224 9.27594 0 8.99994 0H6.99994C6.72394 0 6.49994 0.224 6.49994 0.5V7H4.49994C4.40399 7.00008 4.31008 7.02774 4.22941 7.07969C4.14874 7.13163 4.08471 7.20568 4.04494 7.293C3.96294 7.472 3.99494 7.681 4.12394 7.829L7.62394 11.829C7.67074 11.8827 7.72852 11.9258 7.79339 11.9553C7.85825 11.9848 7.92868 12 7.99994 12C8.14394 12 8.28094 11.937 8.37594 11.829L11.8759 7.829C12.0059 7.682 12.0359 7.472 11.9549 7.293Z",
    fill: "#3176BC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5 11V14H2.5V11H0.5V15C0.5 15.553 0.948 16 1.5 16H14.5C15.053 16 15.5 15.553 15.5 15V11H13.5Z",
    fill: "#3176BC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13154_200137"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadCsvTemplate);
export default __webpack_public_path__ + "static/media/Download-CSV-Template.10c28135d9258883109ba0b7e1fb0f07.svg";
export { ForwardRef as ReactComponent };